<template>
  <div class="forget-container">
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
        <div style="color: transparent">占位符</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <el-form
          ref="passForm"
          :model="form"
          class="pass-form"
          :rules="passRules"
          size="mini"
        >
          <el-form-item v-if="!isGetphone" prop="phone">
            <el-input
              v-model.trim="form.phone"
              type="text"
              placeholder="请输入注册手机号"
              maxlength="18"
              show-word-limit
              autocomplete="off"
            >
              <zr-icon slot="prefix" icon="mobile-alt"></zr-icon>
            </el-input>
          </el-form-item>
          <el-form-item v-if="!isGetphone" prop="verificationCode">
            <el-input
              v-model.trim="form.verificationCode"
              type="text"
              placeholder="请输入验证码"
              maxlength="6"
              show-word-limit
              autocomplete="off"
            >
              <zr-icon slot="prefix" icon="mobile-alt"></zr-icon>
            </el-input>
            <el-button
              class="send-code-btn"
              type="primary"
              :disabled="countdown > 0"
              @click="sendVerificationCode"
            >
              {{ countdown > 0 ? `${countdown}s后可重发` : "获取验证码" }}
            </el-button>
          </el-form-item>
          <el-form-item v-if="isGetphone" prop="password">
            <el-input
              v-model.trim="form.password"
              type="password"
              placeholder="设置密码"
              autocomplete="new-password"
              ><zr-icon slot="prefix" icon="unlock"></zr-icon
            ></el-input>
          </el-form-item>
          <el-form-item v-if="isGetphone" prop="confirmPassword">
            <el-input
              v-model.trim="form.confirmPassword"
              type="password"
              placeholder="确认密码"
              autocomplete="new-password"
              ><zr-icon slot="prefix" icon="unlock"></zr-icon
            ></el-input>
          </el-form-item>
          <el-form-item v-if="!isGetphone">
            <el-row>
              <el-col :span="12">
                <el-button
                  class="register-btn"
                  type="primary"
                  :disabled="countdown === 0"
                  @click.native.prevent="handleNextStep"
                >
                  <zr-icon icon="pencil-alt"></zr-icon> 下一步
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="isGetphone">
            <el-row>
              <el-col :span="12">
                <el-button
                  class="register-btn"
                  type="primary"
                  :disabled="countdown === 0"
                  @click.native.prevent="handleModify"
                >
                  <zr-icon icon="pencil-alt"></zr-icon> 修改密码
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :span="6">
                <router-link class="link-login" to="/login">
                  <div style="margin-top: 10px; margin-left: 30px">
                    <zr-icon icon="door-open"></zr-icon> 登录
                  </div>
                </router-link>
              </el-col>
              <el-col :span="6">
                <router-link class="link-login" to="/">
                  <div style="margin-top: 10px; margin-left: 30px">
                    <span class="fa fa-home"> 首页</span>
                  </div>
                </router-link>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { isPhone, isPassword } from "zr-util/src/utils/comm/validate";
import {
  modifyPasswordByPhoneAndCode,
  resetPassword,
  sendVerificationCode,
  validVerificationCode,
} from "@api/recruit/user/acl";
import { messageDuration } from "@/config/settings";
import {encryptedData} from "@/utils/encrypt";

export default {
  username: "phoneLoadPassword",
  directives: {
    focus: {
      inserted(el) {
        el.querySelector("input").focus();
      },
    },
  },
  data() {
    return {
      isGetphone: false,
      getPhoneIntval: null,
      countdown: 0,
      timer: null,
      phoneCode: "获取验证码",
      showRegister: false,
      nodeEnv: process.env.NODE_ENV,
      title: this.$baseTitle,
      form: {
        verificationCode: "",
        phone: "",
        password: "",
        confirmPassword: "",
      },
      passRules: {
        phone: [
          {
            required: true,
            trigger: "blur",
            message: "输入手机号码/身份证号",
          },
        ],
      },
      loading: false,
      passwordType: "password",
    };
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    this.clearCountdown();
  },
  async created() {
    this.isGetphone = false;
  },
  methods: {
    // 发送验证码
    async sendVerificationCode() {
      if (!this.form.phone || this.form.phone === "") {
        this.$message.warning("请输入手机号");
        return;
      }
      if (!isPhone(this.form.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      try {
        // await this.mockSendCode()
        const param = {
          phone: this.form.phone,
        };
        const result = await sendVerificationCode(param);
        var res = JSON.parse(result);
        if (res.success) {
          this.$message.success("验证码已发送");
          this.startCountdown();
        } else {
          this.$message.error("发送验证码失败， " + res.msg);
        }
      } catch (error) {
        this.$message.error("发送验证码失败，请重试");
        console.error("发送验证码失败:", error);
      }
    },
    // 模拟发送验证码（实际项目中替换为真实API调用）
    // mockSendCode() {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve({ success: true })
    //     }, 1000)
    //   })
    // },
    // 开始倒计时
    startCountdown() {
      this.countdown = 120;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearCountdown();
        }
      }, 1000);
    },
    // 清除倒计时
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    isCodeValid() {
      return (
        this.form.verificationCode.length === 6 &&
        /^\d{6}$/.test(this.form.verificationCode)
      );
    },
    // 处理下一步操作
    async handleNextStep() {
      if (!this.form.verificationCode || this.form.verificationCode === "") {
        this.$message.warning("请输入6位数字验证码");
        return;
      }
      if (!this.isCodeValid) {
        this.$message.warning("请输入6位数字验证码");
        return;
      }
      // 这里调用验证接口
      const param = {
        phone: this.form.phone,
        verificationCode: this.form.verificationCode,
      };
      const result = await validVerificationCode(param);
      var res = JSON.parse(result);
      if (res.success) {
        this.$message.success("验证成功，请重置密码");
        this.isGetphone = true;
      } else {
        this.$message.error("验证失败" + res.msg);
      }
    },
    /**
     * 密码校验（必须包含：字母、数字、特殊字符，长度 ≥ 10）
     * @param {string} password - 待校验密码
     * @returns {Object} 校验结果
     */
    checkPasswordStrength(password) {
      const result = {
        valid: false,
        errors: [],
        checks: {
          length: false,
          letter: false,
          number: false,
          special: false,
        },
      };
      // 检查长度
      if (!password || password.length < 10) {
        result.errors.push("密码长度至少10位");
      } else {
        result.checks.length = true;
      }
      // 检查字母（必须同时包含大小写）
      const hasLower = /[a-z]/.test(password);
      const hasUpper = /[A-Z]/.test(password);
      if (hasLower && hasUpper) {
        result.checks.letter = true;
      } else {
        result.errors.push("密码必须同时包含大小写字母");
      }
      // 检查数字
      if (/\d/.test(password)) {
        result.checks.number = true;
      } else {
        result.errors.push("密码必须包含数字");
      }
      // 检查特殊字符
      if (/[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/.test(password)) {
        result.checks.special = true;
      } else {
        result.errors.push("密码必须包含特殊字符");
      }
      // 判断是否通过
      result.valid = result.errors.length === 0;
      return result;
    },
    async handleModify() {
      // if (!this.checkPasswordStrength(this.form.password)) {
      //   this.$message.warning("密码不能少于6位");
      //   return;
      // }
      var checkRes = this.checkPasswordStrength(this.form.password);
      if (!checkRes.valid) {
        this.$message.error(
            "密码必须包含字母,数字,特殊字符,且长度不少于10位！"
        );
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.warning("两次输入不一致，请确认！");
        return;
      }
      let encryPassword = await encryptedData(this.form.password)
      const param = {
        loginParameter: this.form.phone,
        verificationCode: this.form.verificationCode,
        password: encryPassword,
      };
      const res = await modifyPasswordByPhoneAndCode(param);
      if (res.success) {
        //do
        this.$message.success({
          showClose: true,
          message: "修改密码成功！请登录",
          duration: messageDuration,
        });
        this.$router.push("/login");
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.forget-container {
  height: 100vh;
  background: url("~@/assets/login_images/bg_earth_sky.jpg") center center fixed
    no-repeat;
  background-size: cover;

  .title {
    font-size: 54px;
    font-weight: 500;
    color: rgba(14, 18, 26, 1);
  }

  .title-tips {
    margin-top: 29px;
    font-size: 26px;
    font-weight: 400;
    color: rgba(14, 18, 26, 1);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .register-btn {
    display: inherit;
    width: 160px;
    height: 50px;
    margin-top: 5px;
    font-size: 18px;
    border: 0;

    &:hover {
      opacity: 0.9;
    }
  }

  .pass-form {
    position: relative;
    max-width: 100%;
    margin: calc((100vh - 499px) / 2) 10% 10%;
    overflow: hidden;

    .forget-password {
      width: 100%;
      margin-top: 40px;
      text-align: left;

      .forget-password {
        width: 129px;
        height: 19px;
        font-size: 20px;
        font-weight: 400;
        color: rgba(92, 102, 240, 1);
      }
    }

    .per-code {
      width: 100px;
      height: 36px;
      font-size: 20px;
      line-height: 36px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      background: #bbc1ce;
    }

    .phone-code {
      width: 120px;
      height: 36px;
      font-size: 14px;
      color: #fff;
      border-radius: 3px;
    }
  }

  .tips {
    margin-bottom: 10px;
    font-size: $base-font-size-default;
    color: $base-color-white;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .title-container {
    position: relative;

    .title {
      margin: 0 auto 40px auto;
      font-size: 34px;
      font-weight: bold;
      color: $base-color-blue;
      text-align: center;
    }
  }

  .svg-container {
    position: absolute;
    top: 14px;
    left: 15px;
    z-index: $base-z-index;
    font-size: 16px;
    color: #d7dee3;
    cursor: pointer;
    user-select: none;
  }

  .show-pwd {
    position: absolute;
    top: 14px;
    right: 25px;
    font-size: 16px;
    color: $base-font-color;
    cursor: pointer;
    user-select: none;
  }

  ::v-deep {
    .el-form-item {
      padding-right: 0;
      margin: 20px 0;
      color: #454545;
      background: transparent;
      border: 1px solid transparent;
      border-radius: 2px;

      &__content {
        min-height: $base-input-height;
        line-height: $base-input-height;
      }

      &__error {
        position: absolute;
        top: 100%;
        left: 18px;
        font-size: $base-font-size-small;
        line-height: 18px;
        color: $base-color-red;
      }
    }

    .el-input {
      box-sizing: border-box;

      .el-input__count {
        .el-input__count-inner {
          background: transparent;
        }
      }

      .el-input__prefix {
        left: 15px;
        line-height: 56px;

        .svg-inline--fa {
          width: 20px;
        }
      }

      input {
        height: 58px;
        padding-left: 45px;
        font-size: $base-font-size-default;
        line-height: 58px;
        color: $base-font-color;
        background: #f6f4fc;
        border: 0;
        caret-color: $base-font-color;
      }
    }
  }
}
.link-login {
  color: $base-color-white;
  font-size: 20px;
}
</style>
